var _Bulb;
import cn from "classnames";
import Bulb from "@crehana/icons/outline/Bulb";
import { useMainMenuContext, useMainMenuTranslation } from "../../MainMenu/hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Feedback = function Feedback(_ref) {
  var feedbackUrl = _ref.feedbackUrl;
  var _useMainMenuTranslati = useMainMenuTranslation(),
    t = _useMainMenuTranslati.t;
  var _useMainMenuContext = useMainMenuContext(),
    themeName = _useMainMenuContext.themeName;
  var isDark = themeName.submenu === 'dark';
  return /*#__PURE__*/_jsxs("a", {
    rel: "noreferrer",
    target: "_blank",
    href: feedbackUrl,
    className: cn('flex items-center font-label mr-16', isDark ? 'text-white hover:text-secondary-main' : 'text-base-lighter hover:text-primary-light'),
    children: [_Bulb || (_Bulb = /*#__PURE__*/_jsx(Bulb, {
      size: 24,
      ignoreColor: true,
      className: "mr-8 fill-current outline-icon"
    })), t('FEEDBACK_LABEL')]
  });
};
export default Feedback;